export default class PaymentMethod {
    constructor({id = 1, method = '', isActive = false, provider = {}} = {}) {
        this.id = id;
        this.method = method;
        this.isActive = isActive;
        this.provider = provider;
    }
}
